import { useContext } from "react";
import { TenantContext } from "./TenantContext";

export const useTenant = () => {
  const tenant = useContext(TenantContext);
  if (tenant === null) {
    throw new Error(
      "TenantContext is null. Make sure useTenant is used within a TenantProvider."
    );
  }
  return tenant;
};